<template>
  <svg
    viewBox="0 0 80 80"
    class="progress-circle-icon"
    aria-hidden="true"
  >
    <circle
      class="progress-circle-icon__background"
      cx="40"
      cy="40"
      r="29"
    />
    <circle
      class="progress-circle-icon__value"
      cx="40"
      cy="40"
      r="29"
    />
  </svg>
</template>

<style scoped>
.progress-circle-icon {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.progress-circle-icon__background,
.progress-circle-icon__value {
  fill: none;
  stroke-width: 7;
}

.progress-circle-icon__background {
  stroke: #e5e5e5;
}

.progress-circle-icon__value {
  stroke: #4941d1;
  stroke-linecap: butt;
  stroke-dasharray: 182;
  stroke-dashoffset: 73;
}
</style>
